"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _themes = require("../vfuk/themes");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CheckBoxWrapper = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    display: flex;
    align-items: center;
    & input {
      width: ${props.size}px;
      height: ${props.size}px;
      accent-color: ${(0, _themes.getLocalThemePrimaryColor)()};
      cursor: pointer;
    }
    & p {
      margin: 0 10px;
    }
  `);
const CustomCheckbox = _ref => {
  let {
    id,
    testId,
    onChange,
    text,
    checked,
    inputSize = 20,
    textSize = 1,
    textJustify = 'center'
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CheckBoxWrapper, {
    size: inputSize
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    id: id,
    checked: checked,
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-test-id': testId
    },
    size: textSize,
    justify: textJustify
  }, text))));
};
var _default = CustomCheckbox;
exports.default = _default;